
import { useStore } from '@/store/index'
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const include = store.state.user.aliveInclude
    
    // const cachedViews = () => {
    //     return ['首页', '订单列表', '订单编辑']
    // //   return store.state.tagViews.cachedViews
    // }
    const key = () => {
        return route.path
    }
    return {
        route,
    //   cachedViews,
        key
    }
}
})
